module.exports=function(scope){ return `{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The match request was processed and the Match Level was 10."
    },
    "data": {
        "matchLevel": 10,
        "sourceFaceMap": {
            "glasses": false,
            "isLowQuality": false,
            "isReplayFaceMap": true,
            "livenessStatus": 0,
        },
        "targetFaceMap": {
            "glasses": false,
            "isLowQuality": false,
            "isReplayFaceMap": true,
            "livenessStatus": 0,
        }
    }
}

<!-- NOTE: Server REST API provides additional properties for this end point -->
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/compare.json.tpl